import PropTypes from 'prop-types';

const originalOneOfType = PropTypes.oneOfType;

PropTypes.oneOfType = (types) => {
	if (Array.isArray(types)) {
		return originalOneOfType(types);
	}

	return originalOneOfType([types]);
};
